import { render, staticRenderFns } from "./NewGapStandComponent.vue?vue&type=template&id=043c31ec&scoped=true"
import script from "./NewGapStandComponent.vue?vue&type=script&lang=js"
export * from "./NewGapStandComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c31ec",
  null
  
)

export default component.exports